import React from "react";

const StatsLoading = () => {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {/* Total drivers skeleton */}
      <div className="flex flex-col items-center space-y-2">
        <div className="animate-pulse bg-gray-200 h-12 w-12 rounded-full"></div>
        <div className="animate-pulse bg-gray-200 h-6 w-16 rounded"></div>
        <div className="animate-pulse bg-gray-200 h-4 w-20 rounded"></div>
      </div>

      <div className="hidden sm:block bg-[#E2E2E2] h-[54px] w-[2px]"></div>

      {/* Driver type skeletons */}
      {Array.from({ length: 5 }).map((_, index) => (
        <React.Fragment key={`skeleton-${index}`}>
          <div className="flex flex-col items-center space-y-2">
            <div className="animate-pulse bg-gray-200 h-12 w-12 rounded-full"></div>
            <div className="animate-pulse bg-gray-200 h-6 w-12 rounded"></div>
            <div className="animate-pulse bg-gray-200 h-4 w-16 rounded"></div>
          </div>
          {index < 4 && <div className="hidden sm:block bg-[#E2E2E2] h-[54px] w-[2px]"></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StatsLoading;
